'use client';

import { c as _c } from "react/compiler-runtime";
import useAmplitude from '@eversports/amplitude-react/useAmplitude';
import { useParams } from 'next/navigation';
import { useEffect, useRef } from 'react';
import getGraphqlForClient from '../../lib/get-graphql-for-client';
import { GCLID_SESSION_STORAGE_KEY } from './gclid.constants';
export function useStoreGclid() {
  const $ = _c(5);
  const {
    venueSlug
  } = useParams();
  const {
    amplitude
  } = useAmplitude();
  const hasLoggedEvent = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  let t2;
  if ($[1] !== amplitude || $[2] !== venueSlug) {
    t1 = () => {
      if (!amplitude || hasLoggedEvent.current) {
        return;
      }
      const searchParams_0 = new URLSearchParams(window.location.search);
      const gclid_0 = searchParams_0.get(GCLID_SESSION_STORAGE_KEY);
      if (!gclid_0) {
        return;
      }
      hasLoggedEvent.current = true;
      logGclidLandingEvent(amplitude, venueSlug);
    };
    t2 = [amplitude, venueSlug];
    $[1] = amplitude;
    $[2] = venueSlug;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
}
function _temp() {
  const searchParams = new URLSearchParams(window.location.search);
  const gclid = searchParams.get(GCLID_SESSION_STORAGE_KEY);
  if (gclid) {
    storeGclid(gclid);
  }
}
async function logGclidLandingEvent(amplitude: ReturnType<typeof useAmplitude>['amplitude'], venueSlug: string | undefined): Promise<void> {
  if (!amplitude) {
    return;
  }
  const venue = venueSlug ? await getGraphqlForClient().VenueForGclidTracking({
    venueSlug
  }).then(response => response.venue).catch(() => undefined) : undefined;
  amplitude.logEvent('Visited page with gclid', {
    url: window.location.href,
    'venue.id': venue?.id,
    'venue.name': venue?.name
  });
}
function storeGclid(value: string): void {
  try {
    sessionStorage.setItem(GCLID_SESSION_STORAGE_KEY, value);
  } catch (error) {
    // do nothing
  }
}